import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface ProductionOrderDetailsPartDocumentsProps extends ProductionOrderScreenProps {
  partId: number | null;
}

const ProductionOrderDetailsPartDocumentsComponent: FC<ProductionOrderDetailsPartDocumentsProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  partId,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      {partId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={partId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsPartDocuments = connect(({ details: { partId } }) => ({ partId }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsPartDocumentsComponent);

export { ProductionOrderDetailsPartDocuments };
